"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.File = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../../_util/config-context");
var input_1 = require("../../input");
exports.File = react_1.default.forwardRef(function File(_a, ref) {
    var filename = _a.filename, percent = _a.percent, button = _a.button, className = _a.className, props = tslib_1.__rest(_a, ["filename", "percent", "button", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-form-upload", className) }, props),
        react_1.default.createElement("div", { className: classPrefix + "-form-upload__inner" },
            react_1.default.createElement(input_1.Input, { readonly: true, placeholder: filename }),
            (percent || percent === 0) && (react_1.default.createElement("span", { className: classPrefix + "-form__help-text--inline" },
                Math.floor(percent),
                "%"))),
        button));
});
exports.File.displayName = "UploadFile";
//# sourceMappingURL=File.js.map